import {
  EventType,
  AuthError,
  AuthenticationResult,
} from "@azure/msal-browser";
import { msalInstance } from "../msal/msalInstance";
import { loginRequest, passwordResetRequest } from "../msal/msalConfig";
import { B2C_POLICIES, REDIRECT_ERROR_CODES } from "@/shared/constants";

export const registerAuthEvents = (): void => {
  msalInstance.addEventCallback((event) => {
    if (
      event.eventType === EventType.ACQUIRE_TOKEN_FAILURE &&
      event.error instanceof AuthError &&
      event.error.message?.includes(REDIRECT_ERROR_CODES.forgotPassword)
    ) {
      msalInstance.loginRedirect(passwordResetRequest);
      return;
    }

    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const result = event.payload as AuthenticationResult;

      const policy = (result.idTokenClaims as { acr?: string })?.acr;

      if (policy === B2C_POLICIES.names.resetPassword) {
        msalInstance.loginRedirect(loginRequest);
        return;
      }
      if (result.account) {
        msalInstance.setActiveAccount(result.account);
      }
    }
  });
};
